module.exports = __webpack_public_path__ + "static/media/NFT.d59b6e73.jpg";